import { User } from '-/models/userManagement/typings.d'
import { GetV1UserByIdResponse } from '-/apis'

export const convertGetUserInfoReturnDataToUser = (data: GetV1UserByIdResponse): User => {
  const {
    pharmacistCert: certificateImageUrls,
    pharmacistSignature: signatureImageUrl,
    idCards: idCardImageUrls,
    blockFlag: disabled,
    channelIds,
    storeId,
    idcard,
    ywxOpenId,
    ywxVerifyStatus,
    pharmacistCertNum,
    ...rest
  } = data

  return {
    ...rest,
    pharmacistCertNum,
    idcard,
    ywxOpenId,
    ywxVerifyStatus,
    channelIds: channelIds.map(String),
    signatureImageUrl,
    certificateImageUrls,
    idCardImageUrls,
    drugstoreId: storeId,
    disabled: !!disabled,
  }
}

export default undefined
